'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_samples$002e$002dSealed$0024package$0024$002dColor$00241 from "./samples.-Sealed$package$-Color$1.js";
var $p;
/** @constructor */
function $c_Lsamples_Sealed$package$$anon$6$$anon$17$$anon$25(evaluator$19) {
  this.LX = null;
  this.LX = evaluator$19;
}
export { $c_Lsamples_Sealed$package$$anon$6$$anon$17$$anon$25 as $c_Lsamples_Sealed$package$$anon$6$$anon$17$$anon$25 };
$p = $c_Lsamples_Sealed$package$$anon$6$$anon$17$$anon$25.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Sealed$package$$anon$6$$anon$17$$anon$25;
/** @constructor */
function $h_Lsamples_Sealed$package$$anon$6$$anon$17$$anon$25() {
}
export { $h_Lsamples_Sealed$package$$anon$6$$anon$17$$anon$25 as $h_Lsamples_Sealed$package$$anon$6$$anon$17$$anon$25 };
$h_Lsamples_Sealed$package$$anon$6$$anon$17$$anon$25.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.v = (function() {
  var v = this.LX.h();
  return ((v instanceof $j_samples$002e$002dSealed$0024package$0024$002dColor$00241.$c_Lsamples_Sealed$package$Color$1) ? new $j_java$002elang$002e$002dObject.$c_s_Some(v) : $j_java$002elang$002e$002dObject.$m_s_None$());
});
$p.h = (function() {
  return this.v();
});
var $d_Lsamples_Sealed$package$$anon$6$$anon$17$$anon$25 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Sealed$package$$anon$6$$anon$17$$anon$25, "samples.Sealed$package$$anon$6$$anon$17$$anon$25", ({
  qr: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_Sealed$package$$anon$6$$anon$17$$anon$25 as $d_Lsamples_Sealed$package$$anon$6$$anon$17$$anon$25 };
